<div class="criterion-viewer">

  <div *ngIf="showAny()" class="criterion any">
    <div class="circle anyCircle"></div>
    <img class="image" src="assets/trialcuration/entrance-yes.svg"/>
    A<span *ngIf="!first">nd a</span>t least one&nbsp; of the following rows must yield true
  </div>

  <div *ngIf="showAll()" class="criterion all">
    <div class="circle allCircle"></div>
    <img class="image" src="assets/trialcuration/entrance-yes.svg"/>
    A<span *ngIf="!first">nd a</span>ll of the following rows&nbsp;must&nbsp;yield true
  </div>

  <div *ngIf="showNone()" class="criterion none">
    <div class="circle noneCircle"></div>
    <img class="image" src="assets/trialcuration/entrance-no.svg"/>
    <span *ngIf="first;else other_content">None of the following rows must yield true</span>
    <ng-template #other_content><span>And none of the following rows must yield true</span></ng-template>
  </div>

  <ng-container *ngIf="criterion && criterion.conditions">
    <gen-condition-viewer *ngFor="let condition of criterion.conditions; let first = first; let last = last"
                          class="condition-viewer-panel"
                          [condition]="condition"
                          [first]="first"
                          [last]="last"
                          [type]="criterion.type"

    ></gen-condition-viewer>
  </ng-container>
</div>
